<template>
  <div class="search-page">
    <!-- 顶部图片（可替换为任意图片地址） -->
    <div class="top-image">
      <img :src="bannerUrl" alt="search-banner" />
    </div>

    <!-- 中间搜索框 -->
    <div class="search-box">
      <el-input
        v-model="keyword"
        placeholder="请输入关键词"
        clearable
        @keyup.enter.native="handleSearch"
      >
        <el-button slot="append" type="primary" @click="handleSearch">搜索</el-button>
      </el-input>
    </div>

    <!-- 结果列表 -->
    <div class="results" v-if="searched">
      <div v-if="loading" class="result-tip">正在搜索...</div>
      <div v-else-if="!results || results.length === 0" class="result-tip">未找到相关结果</div>
      <template v-else>
        <div class="result-tip">已找到 {{ results.length }} 个相关结果</div>
        <ul class="result-list">
          <li v-for="(item, idx) in results" :key="idx" class="result-item" @click="goItem(item)">
            <h3 class="title" v-html="highlightText(item.title || item.name || '未命名条目')"></h3>
            <p class="desc" v-if="item.description || item.summary" v-html="highlightText(item.description || item.summary)"></p>
            <div class="meta">
              <span class="badge">{{ item.module || '其他' }}</span>
              <span class="date" v-if="item.date">{{ formatDate(item.date) }}</span>
            </div>
          </li>
        </ul>
      </template>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'Search',
  data() {
    return {
      bannerUrl: require('../assets/img/banner1.png'),
      keyword: '',
      results: [],
      loading: false,
      searched: false,
      testData: [
      {
        title: '测试新闻：CRISPR-AsCas12f1 控制植物青枯病',
        description: '来自新闻中心的示例摘要，点击可跳转到一个内部路径。',
        path: '/news/1001',
        module: '新闻中心',
        date: '2025-01-19 11:47'
      },
      {
        title: '技术平台：噬菌体Paride 可裂解革兰氏阳性菌',
        description: '技术平台的介绍性内容展示，看看排版效果。',
        path: '/platform/2002',
        module: '技术平台',
        date: '2025-09-14 10:43'
      },
      {
        title: '产品服务：猫弩特T_A（噬菌体冻干粉）',
        description: '一段较长的描述文字用于测试多行显示与样式换行。',
        path: '/product/detail/3003',
        module: '产品服务',
        date: '2025-03-11 14:03'
      },
      {
        title: '外部链接示例（新窗口打开）',
        summary: '携带 linkUrl 时会以新标签打开以示区分',
        linkUrl: 'https://example.com',
        module: '外部',
        date: '2025-05-20 18:10'
      }
    ]
    }
  },
  created() {

  },
  methods: {
    async handleSearch() {
      this.searched = true
      const q = (this.keyword || '').trim()
      if (!q) {
        this.results = []
        return
      }
      this.loading = true
      try {
        // 期望后端提供 /api/search?keyword=xxx 接口
        const res = await this.$http.post('/api/content/search', { title: q })
        const ok = res && res.data && (res.data.success || res.data.code === 200)
        const list = ok ? (res.data.data.list || res.data.data.list || []) : []
       
        const normalized = (Array.isArray(list) ? list : []).map(it => ({
          ...it,
          module: it.module || it.categoryName || it.section || '其他',
          date: it.date || it.publishTime || it.createTime || it.updateTime || ''
        }))
        this.results = normalized
      } catch (e) {
        // 出错时给出空结果
        this.results = this.testData
        // eslint-disable-next-line no-console
        console.error('搜索失败', e)
      } finally {
        this.loading = false
      }
    },
    // 文本高亮（对当前关键词进行包裹），包含转义，安全输出
    highlightText(text) {
      const source = String(text == null ? '' : text)
      const q = String(this.keyword || '').trim()
      if (!q) return this.escapeHtml(source)
      const escaped = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const regex = new RegExp(escaped, 'gi')
      return this.escapeHtml(source).replace(regex, match => `<span class="hl">${this.escapeHtml(match)}</span>`)
    },
    escapeHtml(s) {
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },
    formatDate(d) {
      const str = String(d || '')
      // 如果是 ISO/时间戳，尽量格式化为 YYYY-MM-DD
      const date = new Date(str)
      if (!isNaN(date.getTime())) {
        const y = date.getFullYear()
        const m = `${date.getMonth() + 1}`.padStart(2, '0')
        const day = `${date.getDate()}`.padStart(2, '0')
        return `${y}-${m}-${day}`
      }
      return str
    },
    goItem(item) {
      // 通用跳转：path > linkUrl，否则不跳
      const path = (item && (item.path || item.linkUrl)) || ''
      if (path) {
        if (String(path).startsWith('http')) {
          window.open(path, '_blank')
        } else {
          this.$router.push(path)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-page {
  min-height: 100vh;
  padding: 6rem 0 0;
  background: #fff;
}

.top-image {
  width: 100%;
  height: 40vh;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.search-box {
  max-width: 960px;
  margin: 2.5rem auto 1.5rem; /* 让搜索框靠近图片下缘 */
  padding: 0 20px;
  position: relative;
  z-index: 2;

  :deep(.el-input) {
    font-size: 16px;
  }
}

.results {
  max-width: 960px;
  margin: 0 auto;
  padding: 0 20px 60px;
}

.result-tip {
  color: #666;
  padding: 12px 4px;
}

.result-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.result-item {
  padding: 14px 10px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color .15s ease;
  &:hover {
    background-color: #fafafa;
  }
  .title {
    font-size: 18px;
    color: #111;
    margin: 0 0 6px 0;
  }
  .desc {
    font-size: 14px;
    color: #666;
    margin: 0;
  }
  .meta {
    margin-top: 8px;
    font-size: 12px;
    color: #888;
    display: flex;
    gap: 12px;
    align-items: center;
    .badge {
      display: inline-block;
      padding: 2px 8px;
      background: #f5f5f5;
      border-radius: 10px;
      color: #666;
    }
  }
}

:deep(.hl) { color: #d0021b; font-weight: 600; }
</style>


